module.exports = require("./lib/_stream_duplex.js")



/*****************
 ** WEBPACK FOOTER
 ** (webpack)/~/node-libs-browser/~/readable-stream/duplex.js
 ** module id = 293
 ** module chunks = 0
 **/